import { useEffect, useState, useContext } from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { commonFilter, NoneArrow } from '../constants/StyleConstants';
import { InventoriesContext } from '../contexts/InventoriesContext';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  formControl: {
    minWidth: 170,
  },
  overflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 170,
  },
}));

const optionAll = { id: 'All', name: 'Todos' };

export const isOptionAllClaimTypes = value => {
  if (typeof value === 'string') {
    return value.isBlank() || value === optionAll.id;
  } else {
    return value.id === optionAll.id;
  }
};

const ClaimTypeSelect = ({ value, setValue, style, title = 'Tipo de reclamo', readOnly, disableOptionAll, defaultAll }) => {
  const [options, setOptions] = useState(disableOptionAll ? [] : [optionAll]);
  const classes = useStyles();
  const { getTheClaimTypes } = useContext(InventoriesContext);

  useEffect(() => {
    getTheClaimTypes().then(res => {
      const options = disableOptionAll ? res : [optionAll, ...res];
      setOptions(options);
    });
  }, []);

  return (
    <div style={style}>
      <FormControl margin="dense" className={classes.formControl}>
        <InputLabel id="select-state-label">{title}</InputLabel>
        <Select
          className={clsx({ [classes.overflow]: !readOnly })}
          IconComponent={readOnly ? NoneArrow : undefined}
          inputProps={{ readOnly: readOnly }}
          margin="dense"
          labelId="select-state-label"
          id="area-select"
          value={defaultAll && value.isBlank() ? optionAll.id : value}
          renderValue={!readOnly ? optionId => options.filter(o => o.id === optionId)[0].name : undefined}
          onChange={e => setValue(e.target.value)}>
          {options &&
            options.map((claimType, index) => (
              <MenuItem key={index} value={claimType.id}>
                {claimType.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ClaimTypeSelect;
